export default "__VITE_ASSET__DJaJQ1Vu__"